import { BankFormState, CompanyFormState } from "company/detail/components/models";
import { getUpdateBankAccountInstruction } from "company/detail/utils";
import { FormSection } from "components/MainSectionTemplate/types";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import React from "react";
import { isNullOrEmptyString } from "shared/utils";

export const bankDetailSection = (company: server.dto.Company, companyFormState: CompanyFormState, formState: BankFormState): FormSection => {
  const hasBankDetails = !isNullOrEmptyString(formState.accountNumber);

  return {
    type: "collapsable",
    title: RESX.BankAccount.BankAccountDetails,
    key: "companyBankDetails",
    fields: [{
      key: "accountNumber",
      label: RESX.BankAccount.AccountNumber,
      render: () => <div>{formState.accountNumber}</div>,
      isEmpty: !formState.accountNumber,
      inPageEdit: {
        initialValue: formState.accountNumber,
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            maxLength={serverReference.constants.bankAccount.maxIbanNumberLength}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
          />
        ),
        type: "confirmOrCancelButton",
        submitChange: (value) => {
          const instruction = getUpdateBankAccountInstruction(company, companyFormState, formState, {
            accountNumber: value
          });
          return window.CoreApi.Company.UpdateDetails(instruction);
        },
      }
    }, {
      key: "beneficiaryName",
      label: RESX.BankAccount.BeneficiaryName,
      render: () => <div>{formState.beneficiaryName}</div>,
      isEmpty: !formState.beneficiaryName,
      hidden: !hasBankDetails,
      inPageEdit: {
        initialValue: formState.beneficiaryName,
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            maxLength={serverReference.constants.bankAccount.maxBeneficiaryNameLength}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
          />
        ),
        type: "confirmOrCancelButton",
        submitChange: (value) => {
          const instruction = getUpdateBankAccountInstruction(company, companyFormState, formState, {
            beneficiaryName: value
          });
          return window.CoreApi.Company.UpdateDetails(instruction);
        },
      }
    }, {
      key: "swiftCode",
      label: RESX.BankAccount.SwiftCode,
      render: () => <div>{formState.swiftCode}</div>,
      isEmpty: !formState.swiftCode,
      hidden: !hasBankDetails,
      inPageEdit: {
        initialValue: formState.swiftCode,
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            maxLength={serverReference.constants.bankAccount.maxSwiftCodeLength}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
          />
        ),
        type: "confirmOrCancelButton",
        submitChange: (value) => {
          const instruction = getUpdateBankAccountInstruction(company, companyFormState, formState, {
            swiftCode: value
          });
          return window.CoreApi.Company.UpdateDetails(instruction);
        },
      }
    }, {
      key: "sortCode",
      label: RESX.BankAccount.BsbNumber,
      render: () => <div>{formState.sortCode}</div>,
      isEmpty: !formState.sortCode,
      hidden: !hasBankDetails,
      inPageEdit: {
        initialValue: formState.sortCode,
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            maxLength={serverReference.constants.bankAccount.maxSortCodeLength}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
          />
        ),
        type: "confirmOrCancelButton",
        submitChange: (value) => {
          const instruction = getUpdateBankAccountInstruction(company, companyFormState, formState, {
            sortCode: value
          });
          return window.CoreApi.Company.UpdateDetails(instruction);
        },
      }
    }, {
      key: "bankAddress",
      label: RESX.BankAccount.Bank,
      render: () => <div>{formState.bankAddress}</div>,
      isEmpty: !formState.bankAddress,
      hidden: !hasBankDetails,
      inPageEdit: {
        initialValue: formState.bankAddress,
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            maxLength={serverReference.constants.bankAccount.maxBankAddressLength}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
          />
        ),
        type: "confirmOrCancelButton",
        submitChange: (value) => {
          const instruction = getUpdateBankAccountInstruction(company, companyFormState, formState, {
            bankAddress: value
          });
          return window.CoreApi.Company.UpdateDetails(instruction);
        },
      }
    }]
  }
}